import { render, staticRenderFns } from "./PurchasePaymentFormCheque.vue?vue&type=template&id=5750df63"
import script from "./PurchasePaymentFormCheque.vue?vue&type=script&lang=js"
export * from "./PurchasePaymentFormCheque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports